/**
 * Personal global (level 'all', sin root, sin alcance) para los selectores de
 * permisos (spec 2026-10-06 Fase 4: se le reduce sin vincularlo como
 * miembro). Leer `users` solo lo permiten las reglas a isSuperAdmin.
 * Cada candidato trae su rol (con id) para decidir por rango quién se puede
 * ajustar (spec 2026-10-07 §4, lib/target_rank.filterAdjustableStaff).
 */
export const staffRoleIds = (roles) => (roles || [])
  .filter((r) => r && r.data && r.data.documents && r.data.documents.level === 'all' && r.data.documents.root !== true)
  .map((r) => r.id);

export const staffCandidates = ({ users, staffIds, memberUids, rolesById }) => (users || [])
  .filter((u) => u && u.data && staffIds.has(u.data.Rol && u.data.Rol.id)
    && u.data.Alcance !== 'empresas' && !(memberUids && memberUids.has(u.id)))
  .map((u) => {
    const rid = u.data.Rol.id;
    return {
      uid: u.id,
      email: u.data.Email || u.id,
      role: rolesById && rolesById.has(rid) ? { ...rolesById.get(rid), id: rid } : null,
    };
  })
  .sort((a, b) => a.email.localeCompare(b.email));

export const loadStaffUsers = async (db, { memberUids } = {}) => {
  const roles = (await db.collection('roles').get()).docs.map((d) => ({ id: d.id, data: d.data() }));
  const ids = staffRoleIds(roles);
  if (!ids.length) return [];
  const rolesById = new Map(roles.map((r) => [r.id, r.data]));
  const refs = ids.map((id) => db.collection('roles').doc(id));
  const users = [];
  for (let i = 0; i < refs.length; i += 10) {
    // eslint-disable-next-line no-await-in-loop
    const s = await db.collection('users').where('Rol', 'in', refs.slice(i, i + 10)).get();
    s.docs.forEach((d) => users.push({ id: d.id, data: d.data() }));
  }
  return staffCandidates({ users, staffIds: new Set(ids), memberUids, rolesById });
};

export default loadStaffUsers;
